import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/lib/i18n";
import Layout from "@/components/site/Layout";
import { PATHS } from "@/lib/translations";

import Home from "@/pages/Home";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfService from "@/pages/TermsOfService";
import ChildSafety from "@/pages/ChildSafety";
import CookiePolicy from "@/pages/CookiePolicy";
import Contact from "@/pages/Contact";
import LegalNotice from "@/pages/LegalNotice";
import NotFound from "@/pages/NotFound";

function App() {
    return (
        <LanguageProvider>
            <BrowserRouter>
                <Layout>
                    <Routes>
                        <Route path={PATHS.home} element={<Home />} />
                        <Route path={PATHS.privacy} element={<PrivacyPolicy />} />
                        <Route path={PATHS.terms} element={<TermsOfService />} />
                        <Route path={PATHS.childSafety} element={<ChildSafety />} />
                        <Route path={PATHS.cookies} element={<CookiePolicy />} />
                        <Route path={PATHS.contact} element={<Contact />} />
                        <Route path={PATHS.legal} element={<LegalNotice />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </Layout>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default App;
